// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ff626c45","488":"db0d1672","553":"134be5ab","667":"6dcc25ac"}[chunkId] + ".chunk.js";
};